(function($) {
jQuery(document).ready(function(){
  
jQuery('.card-message-content').html();
  
     $('.product__main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product__thumbnails'
});
$('.product__thumbnails').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.product__main',
  dots: false,
  //centerMode: true,
  focusOnSelect: true
});
  
 });
  
  
})(jQuery);
  
  
    
    